module.exports = __webpack_public_path__ + "static/media/nft-1.c7ce7cf8.png";